import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { inputCls } from './shared';

const EMPTY = { name: '', city: '', address: '', phone: '', email: '', contact_name: '', commission_split: 50 };
const FIELDS = [
  ['name', "Nom de l'agence *", 'col-span-2'],
  ['contact_name', 'Responsable', ''],
  ['city', 'Ville', ''],
  ['phone', 'Téléphone', ''],
  ['email', 'E-mail', ''],
  ['address', 'Adresse', 'col-span-2'],
];

export const ExternalPartnerDialog = ({ open, onClose, onDone }) => {
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async () => {
    if (!form.name.trim()) { toast.error("Le nom de l'agence est requis"); return; }
    const split = Number(form.commission_split);
    if (form.commission_split === '' || split < 0 || split > 100) { toast.error('Pourcentage invalide (0 à 100)'); return; }
    setBusy(true);
    try {
      const payload = Object.fromEntries(Object.entries(form).map(([k, v]) => [k, v === '' ? null : v]));
      await api.post('/partnerships/external', { ...payload, commission_split: split });
      toast.success('Agence partenaire ajoutée'); setForm(EMPTY); onClose(); onDone();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Erreur'); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="external-partner-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl text-[#2B3A2C]">Ajouter une agence manuellement</DialogTitle>
          <DialogDescription>Pour une agence hors plateforme : le partenariat est actif tout de suite et vous suivez vous-même les clients et commissions.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          {FIELDS.map(([k, label, cls]) => (
            <label key={k} className={`text-xs font-semibold text-gray-600 ${cls}`}>{label}
              <input value={form[k]} onChange={set(k)} className={inputCls} data-testid={`external-${k}-input`} />
            </label>
          ))}
          <label className="col-span-2 text-xs font-semibold text-gray-600">Part de commission pour l'agence qui recommande (%)
            <input type="number" min="0" max="100" value={form.commission_split} onChange={set('commission_split')} className={inputCls} data-testid="external-split-input" />
          </label>
        </div>
        <Button onClick={submit} disabled={busy} className="w-full bg-[#B85C38] hover:bg-[#a04d2f] text-white rounded-xl" data-testid="external-partner-submit">
          {busy && <Loader2 className="w-4 h-4 mr-1.5 animate-spin" />} Ajouter le partenaire
        </Button>
      </DialogContent>
    </Dialog>
  );
};
